<div *ngIf="path!='link'">
    <button class="btn btn-outline-primary" (click)="openPickerModel()" [disabled]="field.templateOptions.disabled">
        Stakeholder responses
    </button>
</div>
<div *ngIf="fromCW">
    <eos-info-template  (submitEvent)="cwSubmit($event)" [model]="newModel"
    [steps]="steps" [formArray]="formArray" [module]="module"></eos-info-template>
</div>
    
 
